import React from 'react'

import Banner from '@f/components/Banner'
import Modal from '@f/components/Modal'
import BottomBanner from '@f-fertighaus/widgets/FloatingBanner/partials/BottomBanner'
import ModalBanner from '@f-fertighaus/widgets/FloatingBanner/partials/ModalBanner'
import SidecarBanner from '@f-fertighaus/widgets/FloatingBanner/partials/SidecarBanner'

import { getTestParam } from '@js/common/utils'
import { get } from '@js/common/api'

void (async () => {
  const hasModal = () => document.body.classList.contains('has-modal')

  const { pagetype } = document.body.dataset
  const onPageBanner = window.SherlockContainer.OnpageBanner || {}

  const delayOffsetHeightCalculation = () =>
    new Promise(resolve => setTimeout(resolve, 1000))

  const activeBanner = Object.keys(onPageBanner).filter(
    banner => Object.keys(onPageBanner[banner].default).length
  )[0]

  const activeBannerPlanout = Object.keys(onPageBanner).filter(
    banner => onPageBanner[banner].planout
  )

  let planoutData = null
  let activeBannerAB
  if (activeBannerPlanout.length) {
    const variant = getTestParam(onPageBanner[activeBannerPlanout[0]].planout)

    const planout = onPageBanner[activeBannerPlanout[0]].planout

    if (planout) {
      planoutData = activeBannerPlanout.reduce((acc, current) => {
        if (variant in onPageBanner[current][planout]) {
          activeBannerAB = current
          return { ...acc, ...onPageBanner[current][planout][variant] }
        }

        return acc
      }, {})
    }
  }

  if (!activeBanner && !activeBannerAB) return

  const data = planoutData || onPageBanner[activeBanner]?.default

  const bannerProps = {
    heading: data.heading,
    copy: data.copy,
    image: {
      imageSrcMobile: data.image_src_mobile,
      imageSrcDesktop: data.image_src_desktop
    },
    illustration: data.illustration_src,
    ctaCopy: data.cta_copy,
    checkmark: [data.checkmark_copy_1, data.checkmark_copy_2].filter(Boolean),
    link: data.cta_url,
    visibility: {
      anonymous: data.is_visible_anonymous,
      activation: data.is_visible_activation,
      conversion_non_prequal: data.is_visible_conversion_non_prequal,
      conversion_prequal: data.is_visible_conversion_prequal,
      handover: data.is_visible_handover
    },
    wtLocation: data.tracking_name,
    wtIndicates: /hausbau-assistent/.test(data.cta_url)
      ? ['funnel-entry']
      : null
  }

  const bannerTypeMap = {
    modal: {
      type: Modal,
      open: 'openModal',
      component: ModalBanner,
      options: {
        className: 'has-grid modal-banner-transition'
      }
    },
    sidecar: {
      type: Banner,
      open: 'openBanner',
      component: SidecarBanner,
      options: {
        className: 'has-animation'
      }
    },
    bottom: {
      type: Banner,
      open: 'openBanner',
      component: BottomBanner,
      options: {
        className: 'has-animation'
      }
    }
  }

  const bannerType = activeBannerPlanout.length ? activeBannerAB : activeBanner
  const localStorageKey = `${bannerType}-banner`

  let alreadyShown = false
  let shouldBeShowForACurrentUser = false

  try {
    if (localStorage.getItem(localStorageKey).includes(pagetype)) {
      alreadyShown = true
    }
  } catch (e) {}

  if (!alreadyShown) {
    const { gsap } = await import(
      /*
        webpackChunkName: "gsap",
        webpackMode: "lazy"
      */
      'gsap'
    )

    const { ScrollTrigger } = await import(
      /*
        webpackChunkName: "ScrollTrigger",
        webpackMode: "lazy"
      */
      'gsap/ScrollTrigger'
    )

    window.requestAnimationFrame = window.requestAnimationFrame.bind(window)
    gsap.registerPlugin(ScrollTrigger)

    let timer

    const openBanner = async () => {
      try {
        if (
          localStorage
            .getItem(localStorageKey)
            .includes(document.body.dataset.pagetype)
        ) {
          alreadyShown = true
        }
      } catch (e) {}

      if (alreadyShown || hasModal()) return

      try {
        const { current_user } = await get('users/current')

        shouldBeShowForACurrentUser =
          current_user && bannerProps.visibility[current_user.ua_user_state]
      } catch (e) {
        shouldBeShowForACurrentUser = bannerProps.visibility.anonymous
      }

      if (!shouldBeShowForACurrentUser) return

      const bannerData = bannerTypeMap[bannerType]
      const bannerObject = new bannerData.type()

      bannerObject[bannerData.open] &&
        bannerObject[bannerData.open]({
          component: <bannerData.component {...bannerProps} />,
          options: bannerData.options
        })

      try {
        const prevShowedPages = localStorage.getItem(localStorageKey) || ''

        if (!prevShowedPages.includes(document.body.dataset.pagetype)) {
          localStorage.setItem(localStorageKey, [
            document.body.dataset.pagetype,
            ...prevShowedPages.split(',')
          ])
        }
      } catch (e) {}

      clearTimeout(timer)
    }

    timer = setTimeout(openBanner, Number(data.trigger_timer || 0) * 1000)

    await delayOffsetHeightCalculation()

    ScrollTrigger.create({
      trigger: document.querySelector('body'),
      start:
        document.body.offsetHeight * Number(data.trigger_scroll || 100) * 0.01,
      onEnter: openBanner
    })
  }
})()
